import { useToast } from "@chakra-ui/react";
import { FC, useCallback } from "react";
import { graphql, useFragment } from "react-relay";
import { useParams } from "react-router-dom";

import { ScheduleListTabContainer_Mutation } from "~/src/__relay_artifacts__/ScheduleListTabContainer_Mutation.graphql";
import { ScheduleListTabContainer_user$key } from "~/src/__relay_artifacts__/ScheduleListTabContainer_user.graphql";
import { useMutationCommit } from "~/src/lib/react-relay";

import { ScheduleListTab } from "./presentations/ScheduleListTab";

export type Props = {
  userRef: ScheduleListTabContainer_user$key;
};

const userFragment = graphql`
  fragment ScheduleListTabContainer_user on User {
    ...ScheduleListTab_user
  }
`;

const deleteMutation = graphql`
  mutation ScheduleListTabContainer_Mutation(
    $input: DeleteScheduleInput!
    $connections: [ID!]!
  ) {
    deleteSchedule(input: $input) {
      deletedScheduleId @deleteEdge(connections: $connections)
    }
  }
`;

export const ScheduleListTabContainer: FC<Props> = ({ userRef }) => {
  const user = useFragment(userFragment, userRef);
  const { siteSlug = "" } = useParams();
  const toast = useToast();

  const deleteMutate =
    useMutationCommit<ScheduleListTabContainer_Mutation>(deleteMutation);

  const handleDeleteClick = useCallback(
    async (scheduleId: string, connectionId: string) => {
      try {
        const res = await deleteMutate({
          variables: {
            input: {
              scheduleId,
            },
            connections: [connectionId],
          },
        });
        const deletedScheduleId = res.deleteSchedule?.deletedScheduleId;
        if (!deletedScheduleId) throw new Error("assertion failed");

        toast({
          title: `スケジュールを削除しました`,
          status: "success",
        });
      } catch (err) {
        toast({ title: "スケジュールの削除に失敗しました", status: "error" });
      }
    },
    [deleteMutate, toast]
  );

  return (
    <ScheduleListTab
      userRef={user}
      siteSlug={siteSlug}
      onDeleteClick={handleDeleteClick}
    />
  );
};
